export const NodesSummaryModel = Symbol.for('NodesSummaryModel');
